var _defs, _path, _path2, _path3, _path4, _clipPath, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 119 119",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "7dok5q5xla",
    x: "-400%",
    width: "600%",
    y: "-400%",
    height: "600%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: "0,0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(228,228,228)"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "tmp"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.500000,0L119,0L119,119L59.500000,119C26.639057,119,0,92.360943,0,59.500000L0,59.500000C0,26.639057,26.639057,0,59.500000,0Z",
    transform: "matrix(1 0 0 1 0.26200194999998 0.07000002499996)",
    filter: "url(#7dok5q5xla)",
    fill: "rgb(255,255,255)",
    stroke: "none",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.500000,104.490000C34.647186,104.490000,14.500000,84.342814,14.500000,59.490000C14.500000,34.637186,34.647186,14.490000,59.500000,14.490000C84.352814,14.490000,104.500000,34.637186,104.500000,59.490000C104.500000,84.342814,84.352814,104.490000,59.500000,104.490000ZM59.620000,21.550000C38.467494,21.550000,21.320000,38.697494,21.320000,59.850000C21.320000,81.002506,38.467494,98.150000,59.620000,98.150000C80.772506,98.150000,97.920000,81.002506,97.920000,59.850000C97.903456,38.704351,80.765649,21.566544,59.620000,21.550000Z",
    fill: "rgb(18,83,250)",
    stroke: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2fj26v25ab)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 37.64922233500000 37.42123676500000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.270000,0.320000L0,0.640000L0,41.550000L0.220000,41.800000C0.590000,42.200000,16.120000,51.560000,16.480000,51.600000C16.868291,51.597376,17.235081,51.421317,17.480000,51.120000C17.540000,50.980000,17.580000,49.270000,17.580000,46.290000L17.580000,41.680000L34.090000,41.680000L34.440000,41.330000L34.790000,40.980000L34.790000,29.130000L34.440000,28.780000C34.141159,28.377843,33.573452,28.292910,33.170000,28.590000C33.099398,28.645622,33.035622,28.709398,32.980000,28.780000L32.630000,29.130000L32.630000,39.510000L17.700000,39.510000L17.700000,24.760000C17.650000,10.180000,17.650000,10.010000,17.440000,9.760000C17.230000,9.510000,14.500000,7.880000,11.140000,5.850000L5,2.160000L32.630000,2.160000L32.630000,16.730000L32.920000,17.040000C33.106605,17.251457,33.369782,17.379835,33.651296,17.396726C33.932811,17.413617,34.209450,17.317628,34.420000,17.130000C34.532552,17.031003,34.621410,16.907970,34.680000,16.770000C34.750000,16.610000,34.790000,13.520000,34.790000,8.660000C34.790000,0.240000,34.790000,0.380000,34.280000,0.110000C34.150000,0,28.620000,0,17.280000,0L0.520000,0ZM11.520000,8.680000L15.520000,11.080000L15.520000,48.580000L8.850000,44.580000L2.230000,40.580000L2.230000,3L4.930000,4.630000Z",
    fill: "rgb(18,83,250)",
    stroke: "none",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.360000,14.680000C42.989804,14.872158,42.766708,15.263554,42.790000,15.680000L42.790000,16.130000L45.630000,19L48.520000,21.870000L24.740000,21.870000L24.470000,22.100000C24.007624,22.481899,23.940597,23.165574,24.320000,23.630000C24.379076,23.700873,24.446193,23.764634,24.520000,23.820000C24.840000,24.010000,25.120000,24.030000,36.650000,24.030000L48.520000,24.030000L45.660000,26.880000C42.830000,29.690000,42.790000,29.690000,42.790000,30.150000C42.766866,30.731879,43.209227,31.227323,43.790000,31.270000C43.925601,31.270354,44.060471,31.250124,44.190000,31.210000C44.530000,31.080000,51.850000,23.820000,52.100000,23.370000C52.430000,22.740000,52.400000,22.690000,48.250000,18.560000C44.650000,14.950000,44.340000,14.670000,43.960000,14.630000C43.758964,14.596279,43.552682,14.613469,43.360000,14.680000Z",
    fill: "rgb(18,83,250)",
    stroke: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M11.300000,8.500000L15.250000,10.900000L15.250000,48.400000L8.580000,44.400000L2,40.400000L2,2.840000L4.700000,4.470000C6.130000,5.370000,9.120000,7.190000,11.300000,8.500000Z",
    opacity: 0.2,
    fill: "rgb(18,83,250)",
    stroke: "none",
    strokeWidth: 1
  })))))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "2fj26v25ab"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 38.5,
    transform: "matrix(1 0 0 1 59.04000000000000 59.57000000000000)",
    fill: "none",
    stroke: "rgb(3,20,250)",
    strokeWidth: 1
  })))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 27.5,
    transform: "matrix(1.56346237451626 0 0 1.56346237451626 59.50892662000001 59.24692466999996)",
    fill: "none",
    stroke: "rgb(18,83,250)",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.8e98274a.svg";
export { ForwardRef as ReactComponent };